import React from "react"

export default ({inversed})  =>
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 50 50"
    style={{ width: '3rem', height: '3rem'}}
  >
    <symbol id="a" viewBox="-11.5 -11.5 23 23">
      <circle fill={inversed? "#FFF":"#313130"} r={11.5} />
      <path
        fill="none"
        stroke={inversed? "#313130": "#FFF"}
        strokeWidth={1.444}
        strokeMiterlimit={10}
        d="M-2.6-5.1L2.6 0l-5.2 5.1"
      />
    </symbol>
    <use
      xlinkHref="#a"
      width={23}
      height={23}
      x={-11.5}
      y={-11.5}
      transform="translate(24.5 24.5)"
      overflow="visible"
    />
  </svg>


// WEBPACK FOOTER //
// ./src/svg/right-arrow-circle.js